import styled, { css } from 'styled-components/macro'
import { theme } from 'styled-tools'
import { media } from 'ui/rwd'

const CONTENT_WIDTH = '1180px'

const pageGutter = css`
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  ${media.sm`
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  `}
  ${media.md`
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  `}
  ${media.lg`
    padding-left: 4rem;
    padding-right: 4rem;
  `}
`

// Global styles in scss/style.scss pin every <main> to a fixed 1280px and center its text.
// The negative inline margin cancels the layout's 15px grid gutter so the header can go full bleed.
const Page = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: auto;
  max-width: none;
  min-width: 0;
  min-height: 100vh;
  margin: 0 -15px;
  overflow-x: hidden;
  text-align: left;
  color: ${theme('black')};

  > footer {
    margin-top: auto;
  }
`

const Section = styled.section`
  width: 100%;
  max-width: ${CONTENT_WIDTH};
  margin: 0 auto;
  ${pageGutter};
  padding-top: 3rem;
  padding-bottom: 3rem;
  ${media.sm`
    padding-top: 4rem;
    padding-bottom: 4rem;
  `}
`

export { Page, Section, pageGutter, CONTENT_WIDTH }
